module.exports = __webpack_public_path__ + "static/media/CardSki1.99bd27b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/registeration/CardSki1.svg
// module id = 116
// module chunks = 0